import { RepositoryAdd } from '#app/routes/mocra+/_form+/components/repositories/add.tsx'
import { RepositoryCard } from '#app/routes/mocra+/_form+/components/repositories/card.tsx'
import { type RepositoryDraft } from '#app/routes/mocra+/_form+/components/repositories/types.ts'
import { Section } from '#app/routes/mocra+/_form+/components/section.tsx'
import { type SectionResources } from '#app/routes/mocra+/_form+/section-resources.ts'

type RepositoryListItem = {
	readonly draft: RepositoryDraft
	readonly errors: readonly string[]
}

type Props = {
	readonly repositories: ReadonlyArray<RepositoryListItem>
	readonly resources: SectionResources
	readonly onAdd: (draft: RepositoryDraft) => void
	readonly onEdit: (index: number) => void
	readonly onRemove: (index: number) => void
}

export function RecordRepositoriesSection({
	repositories,
	resources,
	onAdd,
	onEdit,
	onRemove,
}: Props) {
	return (
		<Section
			title="Record repositories"
			description="List each system or archive that stores MoCRA-relevant records."
			mocraSections={resources.mocraSections}
			templates={resources.templates}
		>
			<div className="space-y-3">
				{repositories.length > 0 ? (
					repositories.map((item, index) => {
						const { draft, errors } = item
						return (
							<RepositoryCard
								key={`${draft.system}-${index}`}
								repository={draft}
								onEdit={() => onEdit(index)}
								onRemove={() => onRemove(index)}
								errors={errors.length > 0 ? [...errors] : undefined}
							/>
						)
					})
				) : (
					<p className="text-muted-foreground text-sm">
						Add your first repository to document where records live.
					</p>
				)}
			</div>
			<RepositoryAdd onSubmit={onAdd} />
		</Section>
	)
}
